import { createCustomSlice } from 'core/utils';
import i18n from 'i18nextInstance';
import orderBy from 'lodash/orderBy';
import { parseSelect } from 'shared/utils';

const initialState = {
    backendConfiguration: [],
    chatbotFeatureList: [],
    chatbotFeatureListLoading: false,
    chatbotJSON: '',
    chatbotJSONLoading: false,
    configurations: {
        frequencies: [],
        import_fields: [],
        integrations: [],
        licenses: []
    },
    cronConfiguration: [],
    error: false,
    featureConfiguration: [],
    featureConfigurationLoading: false,
    featureConfigurationProcessing: false,
    loaded: false,
    notificationTypes: [],
    notificationTypesLoading: false,
    notifications: [],
    notificationsLoading: false,
    platformConfigurationLoading: false,
    platformConfigurationProcessing: false,
    servicesConfiguration: [],
    templates: [],
    templatesLoading: false
};

const configSlice = createCustomSlice({
    initialState,
    name: 'config',
    reducers: {},
    saga: [
        'createNotification',
        'createTemplate',
        'deleteChatbotFeature',
        'deleteChatbotNode',
        'deleteNotification',
        'deleteTemplate',
        'getBackendConfiguration',
        'getChatbotFeatureList',
        'getChatbotJSON',
        'getConfig',
        'getConfigNotifications',
        'getConfigNotificationTypes',
        'getConfigTemplates',
        'getCronConfiguration',
        'getFeatureConfiguration',
        'getServicesConfiguration',
        'updateBackendConfiguration',
        'updateChatbotFeature',
        'updateCronConfiguration',
        'updateFeatureSchema',
        'updateNotification',
        'updateServicesConfiguration',
        'updateTemplate',
        'upsertChatbotNode'
    ]
});

export const parseConfig = data => {
    const {
        frequencies = [],
        general = [],
        import_fields = [],
        integrations = [],
        licenses = [],
        psychosocial_risk = [],
        sso_login,
        quizzes = []
    } = data;
    return ({
        ...Object.fromEntries(general.map(({ name, value }) => [name, value])),
        frequencies: parseSelect(frequencies),
        import_fields,
        integrations,
        licenses: orderBy(licenses, ['label']),
        quizzes: orderBy(parseSelect([
            ...psychosocial_risk.map(e => ({ ...e, type: 'psychosocial_risk' })),
            ...quizzes.map(e => ({ ...e, type: 'quiz' }))
        ]), 'name'),
        sso_login
    });
};

export const parseNotification = item => {
    const { doctor, enabled, specialty, template } = item;
    return ({
        ...item,
        doctor_label: doctor?.id ? `${ doctor?.last_name }, ${ doctor?.first_name }` : '',
        enabled_label: enabled ? i18n.t('Si') : i18n.t('No'),
        specialty_label: specialty?.name ?? '',
        template_label: template?.name ?? ''
    });
};

export const configActions = configSlice.actions;

export default configSlice.reducer;
